import { RootState } from '@client/redux/types';
import { NAMESPACE } from './constants';

export const getSemanticArticlesCarouselData = (state: RootState) => state[NAMESPACE];
export const getIsLoading = (state: RootState) => state[NAMESPACE].loading;
